<template>
  <div class="business">
    <div class="title">
      <div class="title-logo"></div>
      <div class="title-right">
        <div class="menu">
          <nx-nav />
        </div>
        <div class="title-user">
          <user-info v-if="!ifLogin"></user-info>
          <login-user v-if="ifLogin" class="tc"></login-user>
        </div>
      </div>
    </div>

    <div class="info-wrap">
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
      <div class="info-table">
        <div class="info-title"></div>
        <div class="info-list">
          <div class="list-title">
            <span>服务器</span>
            <span>cpu使用率</span>
            <span>内存使用率</span>
            <span>mysql状态</span>
            <span>mongo状态</span>
            <span>添加关注</span>
          </div>
          <div class="list-item" v-for="(item,index) in thisPage" :key="index">
            <span class="server">{{item.name}}</span>
            <span ref="cpu"></span>
            <span ref="mem"></span>
            <span class='database'>
              <div v-if="item.mysql!=='无'" class='database-status' :class="{alert: item.mysql==='断线'}"></div>
              <img src="../../assets/reset.png" v-if="item.mysql!=='无'" @click="openDialog(item.name,'mysql')">
            </span>
            <span class='database'>
              <div v-if="item.mongo!=='无'" class='database-status' :class="{alert: item.mongo==='断线'}"></div>
              <img src="../../assets/reset.png" v-if="item.mongo!=='无'" @click="openDialog(item.name,'mongo')">
            </span>
            <span class="tableLike">
              <img :src="getLike(item.name)" @click="addLikes(item.name)" alt />
            </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width='30%'>
      <span>是否确定要重启{{resetDatabaseName}}的{{resetDatabaseType}}数据库?</span>
      <span slot='footer'>
        <el-button type='primary' @click="confirmReset">确定</el-button>
        <el-button @click="dialogVisible=false">取消</el-button>
      </span>
    </el-dialog>
    <!-- <div class="info-page">
      <el-pagination background layout="prev,pager,next" :page-size="pageCount" :total="staff.length" @current-change="handleCurrentChange"></el-pagination>
    </div>-->
    <tabBottom></tabBottom>
  </div>
</template>

<script>
import NxNav from "../NxNav";
import UserInfo from "../user";
import tabBottom from "../tabBottom";
const likeImg = require("@/assets/like.png");
const unlikeImg = require("@/assets/unlike.png");
import { setUserInfo } from '@/js/utils'
import loginUser from "../user2";
export default {
  components: {
    NxNav,
    UserInfo,
    tabBottom,
    loginUser
  },
  data() {
    return {
      showTime: "",
      servers: [],
      thisPage: [],
      pageTotal: null,
      pageNum: 1,
      pageCount: 5,
      loadingShow: true,
      likeText: [],
      dialogVisible: false,
      resetDatabaseName:'',
      resetDatabaseType:''
    };
  },
  mounted() {
    var me = this;
    this.loadingShow = true;
    me.getShowTime();
    me.getServers();
    me.getLikeServer();
    setInterval(me.getShowTime, 1000);
    if (!me.ifLogin) {
      setTimeout(function() {
        me.loadingShow = false;
        me.$router.push({ path: "/web" });
      }, 500);
    }
  },
  sockets: {
    connect: function() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    authenticated: function(data) {
      var token = localStorage.getItem("jwt");
      this.$socket.emit("queryUser", token);
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        this.$router.push({ path: "/" });
      }
    },
    userInfo: function(data) {
      setUserInfo.call(this, data)
      this.getServers();
      this.getLikeServer();
    },
    serversjson: function(data) {
      var me = this;
      me.servers = data.servers;
      // console.log('me.servers',me.servers);
      me.pageInit();
      setTimeout(function() {
        me.loadingShow = false;
      }, 500);
    },
    getLikeServer(data) {
      var data = data[0].attentionServer;
      // console.log('data',data)
      if (!data) {
        this.likeText = [];
      } else {
        if (data == "[20,21]" || data == "[21,20]") {
          this.likeText = [20, 21];
        } else if (data == "[20]") {
          this.likeText = [20];
        } else if (data == "[21]") {
          this.likeText = [21];
        }
      }
    },

    resetDatabase(data){
      console.log('data :>> ', data)
      this.$message({
        message: data,
        type: 'success'
      });
    }
  },
  methods: {
    getShowTime() {
      var me = this;
      var nowTime = new Date();
      var year = nowTime.getFullYear();
      var month = nowTime.getMonth() + 1;
      var date = nowTime.getDate();
      var hour = nowTime.toLocaleTimeString();
      me.showTime = year + "-" + month + "-" + date + " " + hour;
    },
    getLikeServer() {
      var me = this;
      console.log("aaaa", this.$store.state.userName);
      me.$socket.emit("getLikeServer", this.$store.state.userName);
    },
    getServers() {
      var me = this;
      me.$socket.emit("serversjson");
    },
    pageInit() {
      var me = this;
      me.thisPage = me.servers.slice(
        (me.pageNum - 1) * me.pageCount,
        me.pageNum * me.pageCount
      );
      console.log('me.thisPage :>> ', me.thisPage);
      me.pageTotal = Math.ceil(me.servers.length / me.pageCount);
      this.$nextTick(() => {
        this.drawCharts();
      });
    },

    // 绘制图表
    drawCharts() {
      var me = this;
      for (var i in this.$refs["cpu"]) {
        var myChart = this.$echarts.init(this.$refs["cpu"][i]);
        myChart.setOption({
          textStyle: {
            color: "#fff"
          },
          title: {
            text: "CPU",
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          },
          tooltip: {},
          xAxis: {
            type: "category",
            axisLine: {
              show: false
            }
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: `{value}%`,
              margin: -6
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              data: me.servers[i].cpuUsageList.map(function(ele, i, arr) {
                return parseFloat(ele);
              }),
              type: "line",
              smooth: true,
              lineStyle: {
                color: "#409eff"
              },
              itemStyle: {
                color: "#309eff"
              }
            }
          ]
        });
      }
      for (var i in this.$refs["mem"]) {
        var myChart = this.$echarts.init(this.$refs["mem"][i]);
        myChart.setOption({
          textStyle: {
            color: "#fff"
          },
          title: {
            text: "内存",
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          },
          tooltip: {},
          xAxis: {
            type: "category",
            axisLine: {
              show: false
            }
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: `{value}%`,
              margin: -6
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              data: me.servers[i].memUsageList.map(function(ele, i, arr) {
                return parseFloat(ele);
              }),
              type: "line",
              smooth: true,
              lineStyle: {
                color: "#409eff"
              },
              itemStyle: {
                color: "#309eff"
              }
            }
          ]
        });
      }
    },
    handleCurrentChange(val) {
      var me = this;
      me.pageNum = val;
      me.pageInit();
    },

    getLike(item) {
      var me = this;
      if (item == "服务器1") {
        if (me.likeText[0] == 20 || me.likeText[1] == 20) {
          return likeImg;
        } else {
          return unlikeImg;
        }
      } else {
        if (me.likeText[0] == 21 || me.likeText[1] == 21) {
          return likeImg;
        } else {
          return unlikeImg;
        }
      }
    },
    addLikes(data) {
      var me = this;
      var text;
      console.log(data, me.likeText.length);
      if (data == "服务器1") {
        if (me.likeText.length == 2) {
          me.likeText = [21];
        } else if (me.likeText.length == 1) {
          if (me.likeText[0] == 20) {
            me.likeText = [];
          } else {
            me.likeText = [20, 21];
          }
        } else {
          me.likeText = [20];
        }
      } else if (data == "服务器2") {
        if (me.likeText.length == 2) {
          me.likeText = [20];
        } else if (me.likeText.length == 1) {
          if (me.likeText[0] == 20) {
            me.likeText = [20, 21];
          } else {
            me.likeText = [];
          }
        } else {
          me.likeText = [21];
        }
      }
      me.$socket.emit("changeAttentionServer2", {
        data: me.likeText,
        name: me.$store.state.userName
      });
      console.log("likeText", me.likeText);
    },
    openDialog(name, type) {
      this.dialogVisible = true
      this.resetDatabaseName = name
      this.resetDatabaseType = type
    },
    confirmReset() {  
      this.$socket.emit('resetDatabase',{ name: this.resetDatabaseName, type: this.resetDatabaseType })
      this.dialogVisible = false
    }
  },
  computed: {
    ifLogin() {
      return this.$store.state.ifLogin;
    },
    userName() {
      return this.$store.state.userName;
    },
    userImage() {
      return this.$store.state.userImage;
    }
  }
};
</script>

<style lang="less" scoped>
.business {
  position: relative;
  padding-bottom: 20px;
  .tc {
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    float: right;
    width: 200px;
  }
  .info-wrap {
    display: flex;
    margin: 0 auto;
    width: 60vw;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg {
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
    .info-top {
      color: #fff;
      display: flex;
      width: 100%;
      height: 10vh;
      justify-content: center;
      align-items: center;
      .info-top-title {
        color: #fff;
        font-size: 14px;
        text-align: left;
        height: 3vh;
        margin: 2vh 1vw;
        font-weight: 350;
      }
    }
    .info-table {
      font-size: 14px;
      text-align: left;
      // background-color: #20252f;
      padding: 0.5vw 1.8vw 0.5vw 1vw;
      overflow: hidden;
      width: 100%;
      margin-bottom: 50px;
      .info-title {
        text-align: center;
        height: 2.6vh;
        line-height: 2.6vh;
        color: #fff;
        span {
          display: inline-block;
          text-align: center;
          color: #fff;
          font-size: 18px;
        }
      }
      .info-list {
        width: 100%;
        color: #fff;
        display: flex;
        flex-direction: column;

        .list-title {
          width: 100%;
          display: flex;
          margin-bottom: 20px;
          span {
            flex: 1;
            text-align: center;
          }
        }
        .list-item {
          display: flex;
          align-items: center;
          padding: 20px 0;
          position: relative;
          background-color: #20252f;
          justify-content: center;
          align-items: center;
          box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
            0 8px 10px 1px rgba(0, 0, 0, 0.14),
            0 3px 14px 2px rgba(0, 0, 0, 0.12);
          border-radius: 10px;
          margin-bottom: 20px;
          span {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            height: 240px;
          }
          .server {
            width: 48px;
            height: 48px;
            background-size: 10%;
            background-position: top;
            line-height: 90px;
            display: inline-block;
            text-align: center;
            background-repeat: no-repeat;
            background-image: url(../../assets/serverIcon.png);
          }
          .database {
            position:relative;
            .database-status {
              width:25px;
              height:25px;
              background:#67C23A;
              border-radius:50%;  
            }
            .alert {
              background: #F56C6C;
            }
            img {
              position:absolute;
              top:50%;
              right:10%;
              transform:translateY(-50%);
              width:20px;
              height:20px;
              cursor:pointer;
            }
          }
          .tableLike {
            img {
              width: 25px;
              cursor: pointer;
            }
          }
        }
        .list-item:nth-child(odd) {
          background: rgba(117, 176, 243, 0.3);
        }
      }
    }
  }
  .ysxy {
    color: #fff;
    font-size: 16px;
    text-decoration: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pc/PCServer.vue